/**
 * Used for configuring a GraphQL operation to be executed in the context of an eluve-admin
 * super user account
 */
export const eluveAdminHasuraContext = {
  headers: {
    'x-hasura-role': 'eluve-admin',
  },
};

/**
 * Used for configuring a GraphQL operation to be executed in the context of an reviewer
 * super user account
 */
export const reviewerHasuraContext = {
  headers: {
    'x-hasura-role': 'reviewer',
  },
};

/**
 * Used for configuring a GraphQL operation to be executed in the context of
 * an ML engineer. ML engineers have tenant-scoped data access through the
 * `tenant_ml_engineers` association.
 */
export const mlEngineerHasuraContext = {
  headers: {
    'x-hasura-role': 'ml-engineer',
  },
};
